import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// For the customer's own administrator. PrimeHive staff pass too, so they can
// see exactly what a customer sees when helping them.
const CompanyAdminRoute = ({ children }) => {
  const { isAuthenticated, isAnyAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return isAnyAdmin ? children : <Navigate to="/dashboards" replace />;
};

export default CompanyAdminRoute;
